import React from 'react';
import { CampaignOrderQueueReviewQueueSummary } from './CampaignOrderQueueReviewQueueSummary';

export const CampaignOrderQueueReviewSummary = ({
  currentCampaignOrder,
  setShowApprovedDialogSuccess,
}) => {
  return (
    <>
      {['PENDING', 'LIVE_PENDING', 'PAUSED_PENDING', 'REJECTED'].includes(currentCampaignOrder?.status) && (
        <CampaignOrderQueueReviewQueueSummary
          currentCampaignOrder={currentCampaignOrder}
          setShowApprovedDialogSuccess={setShowApprovedDialogSuccess}
        />
      )}
    </>
  );
};
